import { createContextAwareHandlers } from './instance';
import axios, { AxiosInstance } from 'axios';

interface CertificateParams {
  type: 'TotalImpact' | 'GiftedImpact' | 'GiftOrderGiven' | 'GiftOrderReceived' | 'Order';
  id: string;
  variants: CertificateVariants[];
  context?: 'WeChooose' | 'MyChooose';
}
interface OrderCertificateParams extends CertificateParams {
  orderId: string;
  isGuestCertificatePreview?: boolean;
}

export const getCertificatesOrderForCustomer = (instance: AxiosInstance) => async ({
  id,
  orderId,
  type,
  variants,
  isGuestCertificatePreview,
}: OrderCertificateParams): Promise<Certificate> => {
  const { data } = await instance.post<Certificate>(`/customers/${id}/orders/${orderId}/certificate`, {
    type,
    variants,
    isGuestCertificatePreview,
  });

  return data;
};
export const getCertificatesForCustomer = (instance: AxiosInstance) => async ({
  id,
  type,
  variants,
  context = 'WeChooose',
}: CertificateParams): Promise<Certificate> => {
  const { data } = await instance.post<Certificate>(`/customers/${id}/certificates`, {
    type,
    variants,
    portalContext: context,
  });

  return data;
};

export const getCertificatesForPartnership = (instance: AxiosInstance) => async ({ id, type, variants }: CertificateParams): Promise<Certificate> => {
  const { data } = await instance.post<Certificate>(`/partnerships/${id}/certificates`, {
    type,
    variants,
  });

  return data;
};

export const getCertificatesForUser = (instance: AxiosInstance) => async ({ id, type, variants }: CertificateParams): Promise<Certificate> => {
  const { data } = await instance.post<Certificate>(`/user/accounts/${id}/certificates`, {
    type,
    variants,
  });

  return data;
};

export const getGiftCardForOrder = (instance: AxiosInstance) => async (name: string, customerId: string, orderId: string): Promise<Blob> => {
  const { data } = await instance.post<Blob>(
    `/customers/${customerId}/orders/${orderId}/giftcard`,
    {
      format: 'Pdf',
      customization: {
        name,
      },
    },
    {
      headers: {
        'Content-Type': 'application/pdf',
      },
      responseType: 'blob',
    },
  );

  return data;
};

export const printGiftCardForOrder = (instance: AxiosInstance) => async (name: string, customerId: string, orderId: string): Promise<Blob> => {
  const { data } = await instance.post<Blob>(
    `/customers/${customerId}/orders/${orderId}/giftcard`,
    {
      format: 'Pdf',
      customization: {
        name,
      },
    },
    {
      headers: {
        'Content-Type': 'application/pdf',
      },
      responseType: 'arraybuffer',
    },
  );

  return new Blob([data], { type: 'application/pdf' });
};

export const downloadFromUrl = async (url: string): Promise<Blob> => {
  const { data } = await axios.get<Blob>(url, {
    responseType: 'blob',
  });

  return data;
};

const handlers = {
  getCertificatesOrderForCustomer,
  getCertificatesForCustomer,
  getCertificatesForPartnership,
  getCertificatesForUser,
  getGiftCardForOrder,
  printGiftCardForOrder,
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const createCertificatesApi = (context: PortalContext) => {
  return createContextAwareHandlers(context, handlers);
};

export default createCertificatesApi;
